'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Select = function Select(_ref) {
  var callback = _ref.callback,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      id = _ref.id,
      options = _ref.options,
      theme = _ref.theme,
      title = _ref.title,
      required = _ref.required,
      optional = _ref.optional;
  return _react2["default"].createElement('label', {
    className: 'nwc--select ' + theme,
    htmlFor: id
  }, _react2["default"].createElement('div', {
    className: 'nwc--label-wrap'
  }, _react2["default"].createElement('strong', {
    className: 'font--14'
  }, title, required === true && _react2["default"].createElement('sup', {
    className: 'font--error font--10'
  }, ' *'), optional === true && _react2["default"].createElement('sup', {
    className: 'font--grey font--10'
  }, ' (optional)'))), _react2["default"].createElement('select', {
    id: id,
    className: fullWidth === true ? 'full-width' : '',
    onChange: function onChange(e) {
      return callback(e.target.value);
    }
  }, options.map(function (item) {
    return _react2["default"].createElement('option', {
      key: item.value,
      value: item.value
    }, item.title);
  })), error !== null && _react2["default"].createElement('aside', {
    className: 'nwc--validation nwc--validation--error font--12'
  }, error));
};

Select.defaultProps = {
  fullWidth: false,
  error: null,
  theme: '',
  title: null,
  required: false,
  optional: false
};
Select.propTypes = {
  callback: _propTypes.PropTypes.func.isRequired,
  error: _propTypes.PropTypes.string,
  fullWidth: _propTypes.PropTypes.bool,
  id: _propTypes.PropTypes.string.isRequired,
  options: _propTypes.PropTypes.array.isRequired,
  theme: _propTypes.PropTypes.string,
  title: _propTypes.PropTypes.string,
  required: _propTypes.PropTypes.bool,
  optional: _propTypes.PropTypes.bool
};
exports["default"] = Select;